module.exports = __webpack_public_path__ + "static/media/intelSoftwareInnovatorLogo.621d97a8.webp";